import { isReviewMode } from "../config/reviewMode";

export function ReviewModeBanner() {
  if (!isReviewMode) return null;
  return (
    <aside className="review-mode-banner no-print" aria-label="Local product review notice">
      <strong>Local product review</strong>
      <span>Synthetic data only · changes reset when the review server restarts</span>
    </aside>
  );
}
